import { useDispatch } from 'react-redux';

import { BINARY_DECOMPOSITION } from '../../../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled } from '../../../../helpers/features/featureFlags';
import usePreviousRevision, { getQueryKey } from '../../../../hooks/api/revisions/useRevision';
import queryClient from '../../../../ReactQuery/client';
import * as DependenciesV2Store from '../../../../redux/dependenciesV2';
import Button, { BUTTON_SIZE, BUTTON_TYPE } from '../../../generic/Button';
import useNewRevision from '../../hooks/useRevision';

/**
 * This button is used to refresh the dependencies for a revision.
 * It will only display if the dependency count has changed.
 */
const PartialResultRefreshButton = () => {
  // Use react-query to get the initial revision data,
  // then use the context-based revision (from Reflux) to continuously poll updates.
  // useNewRevision: context-based revision hook (Reflux).
  // usePreviousRevision: react-query-based revision hook.
  const newRevision = useNewRevision();
  const locator = newRevision.data?.locator || '';
  const { data: previousRevision, isLoading } = usePreviousRevision(locator);
  const dispatch = useDispatch();
  const newDependencyCount = newRevision.data?.dependency_count || 0;
  const oldDependencyCount = previousRevision?.dependency_count || 0;
  const isBinaryDecompositionEnabled = useIsFeatureEnabled(BINARY_DECOMPOSITION);

  if (newDependencyCount === oldDependencyCount || !isBinaryDecompositionEnabled || isLoading) {
    return null;
  }

  return (
    <Button
      type={BUTTON_TYPE.ANCHOR}
      size={BUTTON_SIZE.SMALL}
      onClick={() => {
        dispatch(DependenciesV2Store.actions.fetchDependencies());
        queryClient.invalidateQueries({ queryKey: getQueryKey(locator) });
      }}>
      Refresh to view latest dependencies
    </Button>
  );
};

export default PartialResultRefreshButton;
